
<template>
  <div>
    <!--loading screen when add video request is being handled-->
    <LoadingScreen :loading="loading" />

    <Dialog
      :title="'Are you sure you want to delete this item?'"
      :text="'This action is not reversible.'"
      :rejectButtonText="'No'"
      :acceptButtonText="'Yes'"
      :toggle="dialog"
      @reject="dialog = false"
      @accept="confirmDeleteItem"
    />

    <div>
      <v-row>
        <v-col cols="12" md="6" class="pt-0">
          <div class="header text-left">Manage Popups</div>
        </v-col>
        <v-col cols="12" md="6" class="action-buttons pt-0">
          <v-btn class="filter-btn" color="#FDBB30">Filter</v-btn>
          <v-btn class="create-btn" color="#00457C" @click="navCreatePopup"
            >Create Popup</v-btn
          >
        </v-col>
      </v-row>
      <v-row v-if="error">
        <v-col cols="12">
          <v-alert type="error">Error occurred. Please try again.</v-alert>
        </v-col>
      </v-row>

      <!-- Table -->
      <TableComponent
        type="popup"
        v-bind:dynamicHeaders="dynamicHeaders"
        v-bind:dynamicWidths="dynamicWidths"
        v-bind:dynamicRowsDetail="dynamicRowsDetail"
        v-on:view-item="viewPopup"
        v-on:edit-item="editPopup"
        v-on:delete-item="openDeleteDialog"
      />
    </div>

    <div
      v-if="currentPopupView !== null"
      class="dialog-popup-wrapper dialog-screen-wrapper"
    >
      <div
        class="content"
        :style="{ backgroundImage: 'url(' + currentPopupView.imgUrl + ')' }"
      >
        <div class="close-section">
          <v-icon size="20px" color="primary" v-on:click="closePopupDialog"
            >mdi-close</v-icon
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TableComponent from "./commons/TableComponent";
import moment from "moment";
import Axios from "axios";
import Dialog from "./commons/Dialog";
import LoadingScreen from "./commons/LoadingScreen";

export default {
  components: {
    TableComponent,
    Dialog,
    LoadingScreen,
  },
  data() {
    return {
      itemDeleteId: null,
      dialog: false,
      dynamicHeaders: [
        { text: "Title", value: "title" },
        { text: "Users", value: "users" },
        { text: "Start Date", value: "startDate" },
        { text: "End Date", value: "endDate" },
        { text: "Actions", value: "actions" },
      ],
      dynamicWidths: ["130px", "70px", "90px", "90px"],
      dynamicRowsDetail: [],
      rawPopupDetails: [],
      currentPopupView: null,
      loading: false,
      error: false,
    };
  },
  created() {
    // Fetch all popups
    Axios.get(process.env.VUE_APP_HOST_SERVER + "/api/popups/get_all").then(
      (res) => {
        console.log("Successfully retrieved all details");
        this.rawPopupDetails = res.data;
        this.dynamicRowsDetail = this.processFetchedData(res.data);
      }
    );
  },
  methods: {
    processFetchedData(rawPopupsData) {
      return rawPopupsData.map(({ _id, title, topics, startDate, endDate }) => {
        const topicDisplay = topics.includes("all") ? "All" : "Topic";
        const startDateDisplay = moment(startDate._seconds * 1000).format(
          "DD MMM YYYY"
        );
        const endDateDisplay = moment(endDate._seconds * 1000).format(
          "DD MMM YYYY"
        );

        return {
          rowId: _id,
          title: title,
          users: topicDisplay,
          startDate: startDateDisplay,
          endDate: endDateDisplay,
          action: { view: "show", edit: "show", delete: "show" },
        };
      });
    },
    navCreatePopup() {
      this.$store.dispatch("loadView", "AddPopups");
    },
    viewPopup(id) {
      this.currentPopupView = this.rawPopupDetails.find(
        (item) => item._id == id
      );
    },
    closePopupDialog() {
      this.currentPopupView = null;
    },
    editPopup(id) {
      this.$router
        .push({ name: "EditPopups", params: { itemId: id } })
        .catch(() => {});
    },
    confirmDeleteItem() {
      this.loading = true; //enable loading screen once user clicks delete
      this.dialog = false;
      // Update MongoDB
      Axios.delete(
        process.env.VUE_APP_HOST_SERVER +
          `/api/popups/delete/${this.itemDeleteId}`
      )
        .then((res) => {
          // Update client data and delete image from S3
          const imgUrlToDelete = this.rawPopupDetails.find(
            (item) => item._id == this.itemDeleteId
          ).imgUrl;
          this.dynamicRowsDetail = this.dynamicRowsDetail.filter(
            (rowDetail) => rowDetail.rowId !== res.data._id
          );
          Axios.delete(process.env.VUE_APP_HOST_SERVER + "/api/file/delete", {
            data: { s3Url: imgUrlToDelete },
          }).then((res) => {
            console.log(res.data);
            this.loading = false;
            this.error = false;
          });
        })
        .catch((err) => {
          console.log(err);
          this.error = true;
        });
    },
    openDeleteDialog(id) {
      this.dialog = true;
      this.itemDeleteId = id;
    },
    openNewPage(redirectUrl) {
      window.open("http://" + redirectUrl);
    },
  },
};
</script>

<style>
.main-panel {
  width: 100%;
}

/* Popup display dialog */

.dialog-popup-wrapper .content {
  background-size: cover;
  border-radius: 20px;
  width: 300px;
  height: 400px;
  padding: 20px;
  background-color: white;
  display: flex;
  flex-direction: column;
}

.dialog-popup-wrapper .image-section {
  flex-basis: 170px;
}

.dialog-popup-wrapper .close-section {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.dialog-popup-wrapper .title-section {
  padding-top: 5px;
  font-size: 14px;
}

.dialog-popup-wrapper .desc-section {
  padding-top: 5px;
  font-size: 9px;
  color: #9b9b9b;
  flex-grow: 1;
}

.dialog-popup-wrapper .action-section {
  flex-basis: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.dialog-popup-wrapper .action-btn {
  width: fit-content;
  font-size: 12px;
  padding: 5px 15px 5px 15px;
  background-color: #204281;
  color: white;
  border-radius: 20px;
}
</style>
